/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { ReactComponent as SvgViewDocuments } from "components/widgets/training/view-documents.svg";
import { connect } from "react-redux";
import CountDown from "react-countdown";
import ChildTraining from "components/widgets/training/RegisteredTraining";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { showModal } from "actions";
import TrainingDetailModal from "components/widgets/training/TrainingDetailModal";
import { Trans } from "react-i18next";
import { SCORMURL, ENV_NAME } from "util/constant";
import Helpers from "util/helpers";
import "components/widgets/training/Training.css";
import TrainingDetailDocuments from "./TrainingDetailDocuments";
import i18n from "i18next";

class RegisteredTraining extends Component {
  rowClassName = "";

  state = {
    showingChildren: true,
  };

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  showDetail = (t, parentId) => {
    //ELearning ise açılmasın
    if (t.trainingMethod.value === 1) return;

    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: "",
      modalContent: (
        <TrainingDetailModal
          training={t}
          trainingType="registered"
          isParent={t.isParent}
          parentId={parentId}
        />
      ),
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  showDocumentsModal = (t) => {
    // Eğitim Dökümanları = 10517
    this.props.showModal({
      modalType: "trainingDetail",
      modalTitle: i18n.t("10517"),
      modalContent: <TrainingDetailDocuments trainingId={t.training.id} />,
      modalFooter: null,
      modalCustomClassName: "modal-xl ttModal",
    });
  };

  renderDate = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleDateString(localStorage.getItem("i18nextLng"));
  };

  renderTime = (dateString) => {
    let d = new Date(dateString);
    return d.toLocaleTimeString(localStorage.getItem("i18nextLng"));
  };

  renderDateTime = (type, dateString) => {
    //1 = ELearning
    if (type !== 1)
      return (
        <>
          {this.renderDate(dateString)}
          <br />
          {this.renderTime(dateString)}
        </>
      );
    else return this.renderDate(dateString);
  };

  renderSuccessStatus = (status) => {
    switch (status) {
      case "NotStarted":
        return (
          <td>
            <div className="durumBaslamadi">
              <Trans desc="Başlamadı">10386</Trans>
            </div>
          </td>
        );

      case "Live":
        return (
          <td>
            <div className="durumCanli">
              <Trans desc="Canlı">10387</Trans>
            </div>
          </td>
        );
      case "Continue":
        return (
          <td>
            <div className="durumDevam">
              <Trans desc="Canlı">10390</Trans>
            </div>
          </td>
        );
      default:
        return <td></td>;
    }
  };

  renderTrainingMethodIcon = (value, isParent) => {
    if (isParent) {
      let icon = "iconmford fo-icon-add";
      if (!this.state.showingChildren) icon = "iconmford fo-icon-remove";
      return (
        <td
          onClick={() => this.toggleChildren()}
          className="showGrup openCloseBtn"
          style={{
            textAlign: "left",
            color: "rgb(45, 150, 205)",
            paddingLeft: "25px",
            fontSize: "20px",
          }}
        >
          <span className={icon}></span>
        </td>
      );
    } else {
      switch (value) {
        case 1:
          return (
            <td onClick={() => this.toggleChildren()}>
              <span className="iconmford fo-icon-tv"></span>
            </td>
          );
        case 3:
          return (
            <td onClick={() => this.toggleChildren()} className="showGrup">
              <span className="iconmford fo-icon-tv">
                <span className="path1"></span>
                <span className="path2"></span>
                <span className="path3"></span>
                <span className="path4"></span>
              </span>
            </td>
          );
        default:
          return (
            <td
              onClick={() => this.toggleChildren()} // onClick={() => this.showDetail(this.props.t, this.props.parentId)}
            >
              <span className="iconmford fo-icon-class"></span>
            </td>
          );
      }
    }
  };

  renderDocumentIcon = (t) => {
    if (!t.hasDocument) return null;

    return (
      <SvgViewDocuments
        onClick={() => this.showDocumentsModal(t)}
        className="training-table__icon-viewdoc"
      />
    );
  };

  renderContinueAction = (training) => {
    if (training.isParent) return null;

    if (
      training.trainingMethod.value === 3 &&
      training.timeplans !== null &&
      training.timeplans.length > 0
    ) {
      const fiveMin = 5 * 60 * 1000; // 5dk kalmis ise sayac gorunmesin
      const startDate = new Date(training.timeplans[0].startDate);
      const diff = startDate - new Date() - fiveMin;
      if (diff > 0) {
        return (
          <td>
            <div className="countdown">
              <CountDown date={Date.now() + diff} />
            </div>
          </td>
        );
      }
    }

    let url = "";
    let langCode = Helpers.getLangCode(localStorage.getItem("i18nextLng"));
    switch (training.buttonType) {
      case "Play":


        // url = `${SCORMURL}/index?employeeCode=${this.props.employeeCode}&registeredTrainingId=${training.registeredTrainingId}&langCode=${langCode}&env=${ENV_NAME}`;



        const postUrl = `${SCORMURL}/index?env=${ENV_NAME}`;

        const payload = {
          employeeCode: this.props.employeeCode,
          registeredTrainingId: training.registeredTrainingId,
          langCode: langCode,
        };

        url = (
          <span
            className="iconmford fo-icon-play-circle-outline"
            style={{ cursor: "pointer" }}
            onClick={() => {
              const newWindow = window.open(postUrl, "_blank");

              // alıcı hazırım deyince gönder
              const readyListener = (e) => {
                if (e.data === "SCORM_READY") {
                  newWindow.postMessage(payload, SCORMURL);
                  window.removeEventListener("message", readyListener);
                }
              };

              window.addEventListener("message", readyListener);
            }}
          />
        );


        // const postUrl = `${SCORMURL}/index?env=${ENV_NAME}`;

        // const payload = {
        //   employeeCode: this.props.employeeCode,
        //   registeredTrainingId: training.registeredTrainingId,
        //   langCode: langCode,
        // };

        // url = <span
        //   className="iconmford fo-icon-play-circle-outline"
        //   style={{ cursor: "pointer" }}
        //   onClick={() => {
        //     const newWindow = window.open(`${postUrl}`, "_blank");
        //     newWindow.name = JSON.stringify(payload);
        //   }}
        // />;

        break;
      case "Redirect":
        url = training.fullURL;
        break;
      default:
        url = "";
        break;
    }

    if (training.buttonType === "Play") {
      return (
        <td>
          {/* <a href={url} target="_blank" rel="noopener noreferrer">
            <span className="iconmford fo-icon-play-circle-outline"></span>
          </a> */}
          {url}
        </td>
      );
    } else if (training.buttonType === "Redirect") {
      return (
        <td>
          <a className="btn-redirect" href={url} target="_blank" rel="noopener noreferrer">
            <Trans desc="Yönlendir">10543</Trans>
          </a>
        </td>
      );
    }
  };

  renderStatusChart = (status) => {
    if (status === 0) {
      return (
        <div className="single-chart">
          <svg viewBox="-2 -2 40 40" className="circular-chart orange">
            <path
              className="circle-bg"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="22.35" className="percentage">
              {status}
            </text>
          </svg>
        </div>
      );
    } else if (status < 100) {
      return (
        <div className="single-chart">
          <svg viewBox="-2 -2 40 40" className="circular-chart orange">
            <path
              className="circle-bg"
              d="M18 2.0845          a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="circle"
              strokeDasharray={`${status}, 100`}
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="22.35" className="percentage">
              {status}
            </text>
          </svg>
        </div>
      );
    } else {
      return (
        <div className="single-chart">
          <svg viewBox="-2 -2 40 40" className="circular-chart green">
            <path
              className="circle-bg"
              d="M18 2.0845
        a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="circle"
              strokeDasharray={`${status}, 100`}
              d="M18 2.0845
                  a 15.9155 15.9155 0 0 1 0 31.831
                  a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <text x="18" y="22.35" className="percentage">
              {status}
            </text>
          </svg>
        </div>
      );
    }
  };

  renderTrainingName = (t) => {
    return (<>
      {t.isRoleTraining && <i className="role-egitim mr-1"></i>}
      {t.isTargetTraining && <i className="hedeflenen-egitim mr-1"></i>}
      {t.training.name}
    </>);
  }

  renderChildren = (t) => {
    if (t.isParent && this.state.showingChildren === false) {
      let childTrainings = t.childTrainings.map((ct) => {
        return (
          <React.Fragment key={ct.key}>
            <DesktopBreakpoint>
              <ChildTraining
                key={ct.key}
                t={ct}
                isChild={true}
                parentId={t.training.id}
              />
            </DesktopBreakpoint>
            <TabletBreakpoint>
              <ChildTraining
                key={ct.key}
                t={ct}
                isChild={true}
                parentId={t.training.id}
              />
            </TabletBreakpoint>
          </React.Fragment>
        );
      });
      return (
        <>
          <DesktopBreakpoint>
            <tr>
              <td colSpan="10">
                <table width="100%">
                  <tbody>
                    <tr className="child">
                      <td className="child">
                        <table className="table">
                          <tbody>{childTrainings}</tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </DesktopBreakpoint>
          <TabletBreakpoint>
            <tr>
              <td colSpan="2" className="accordionArea">
                <div className="accordion" id="accordionDays">
                  {childTrainings}
                </div>
              </td>
            </tr>
          </TabletBreakpoint>
        </>
      );
    }
  };

  renderTabletModeDetail = (t) => {
    if (!this.state.showingChildren) {
      return (
        <tr className="child">
          <td className="child" colSpan="2">
            <table>
              <tbody>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Yer">10016</Trans>
                    </div>
                  </td>
                  <td>{t.trainingLocation ?? ""}</td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Süre">10017</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? `${t.timeplans[0].duration}`
                      : null}
                    <sup>
                      <Trans desc="GÜN">10388</Trans>
                    </sup>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Durum">10018</Trans>
                    </div>
                  </td>
                  <td>
                    <div id="durumChart_1" data-percent="34">
                      <div>{this.renderStatusChart(t.score)}</div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Başarı">10019</Trans>
                    </div>
                  </td>
                  {this.renderSuccessStatus(t.successStatus)}
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Başlangıç">10020</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? this.renderDateTime(
                        t.trainingMethod.value,
                        t.timeplans[0].startDate
                      )
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Bitiş">10021</Trans>
                    </div>
                  </td>
                  <td>
                    {t.timeplans !== null && t.timeplans.length > 0
                      ? this.renderDateTime(
                        t.trainingMethod.value,
                        t.timeplans[0].endDate
                      )
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Tekrarlanan Eğitim">10738</Trans>
                    </div>
                  </td>
                  {t.isDuplicateTraining ? i18n.t("10504") : i18n.t("10505")}
                </tr>

                <tr>
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Importance Level Code">importanceLevelCode</Trans>
                    </div>
                  </td>
                  {t.importanceLevelCode}
                </tr>


                <tr data-dt-row="9" data-dt-column="7">
                  <td>
                    <div className="tableTitle">
                      <Trans desc="Dokumanlar">10178</Trans>
                    </div>
                  </td>
                  <td className="u-centered">{this.renderDocumentIcon(t)}</td>
                </tr>
                <tr>
                  <td>
                    <div className="tableTitle"></div>
                  </td>
                  {this.renderContinueAction(t)}
                </tr>
                {this.renderChildren(t)}
              </tbody>
            </table>
          </td>
        </tr>
      );
    } else return null;
  };

  render() {
    const { t, isChild } = this.props;
    return (
      <>
        <DesktopBreakpoint>
          <tr className="grupEgitim" key={t.key}>
            {this.renderTrainingMethodIcon(t.trainingMethod.value, t.isParent)}
            <td
              className="showGrup" style={{ verticalAlign: "middle" }}
              onClick={() => this.showDetail(t, this.props.parentId)}
            >

              {t.programTypeCode == 0
                ? this.renderTrainingName(t)
                : <strong style={{
                  display: "inline-flex",
                  alignItems: "center",
                  "gap": "8px"
                }} >

                  <svg
                    // viewBox="0 0 360 483.3"
                    viewBox="100 100 200 200"
                    style={{
                      width: 40,
                      margin: "0 auto",
                      height: "auto",
                      boxSizing: "border-box",
                      minWidth: "40px"
                    }}
                  >
                    <title>Ford Pro Logo</title>


                    <g>
                      <g>
                        <path
                          fill="#00095B"
                          d="M107.1904297,166.3092499h18.6459961c14.2714844,0,21.9453125,6.8847656,21.9453125,18.4316406
          c0,10.8291016-8.7495117,17.4267578-19.1484375,17.4267578h-9.9682617v17.2119141h-11.4746094V166.3092499z
          M126.7685547,192.1276093c6.0961914,0,9.0366211-2.1513672,9.0366211-7.8173828
          c0-6.3105469-3.7294922-7.9609375-10.184082-7.9609375h-6.9560547v15.7783203H126.7685547z"
                        />

                        <path
                          fill="#00095B"
                          d="M154.015625,166.3092499h19.3632812c14.1992188,0,21.9453125,4.8769531,21.9453125,16.0644531
          c0,5.953125-2.2949219,9.8251953-6.5976562,12.4785156
          c4.2304688,1.3632812,6.3818359,5.0917969,6.3818359,9.6103516v14.9169922
          h-11.4746094v-13.6259766c0-4.0878906-1.9355469-5.3789062-5.378418-5.3789062h-12.7651367v19.0048828H154.015625V166.3092499z
          M174.3110352,191.0514374c6.1674805,0,9.0366211-1.8642578,9.0366211-7.7451172
          c0-5.59375-3.8012695-6.9570312-10.184082-6.9570312h-7.6733398v14.7021484H174.3110352z"
                        />

                        <path
                          fill="#00095B"
                          d="M201.9306641,193.2028046c0-18.1435547,11.4746094-27.6103516,26.0332031-27.6103516
          c14.4873047,0,24.6708984,9.4667969,24.6708984,26.75
          c0,18.0722656-11.3310547,27.7539062-25.9619141,27.7539062
          C212.1865234,220.0963593,201.9306641,210.5582733,201.9306641,193.2028046z
          M226.8164062,210.0563202c9.0361328,0,13.9130859-6.3105469,13.9130859-17.3554688
          c0-10.3984375-4.2314453-17.0683594-13.1953125-17.0683594
          c-9.0371094,0-13.7695312,6.5976562-13.7695312,17.7138672
          C213.7646484,204.0319061,218.1386719,210.0563202,226.8164062,210.0563202z"
                        />
                      </g>

                      <g>
                        <path
                          fill="#00095B"
                          d="M255.515625,167.9781952h-3.1474609v-1.7070312h8.125v1.7070312h-3.1464844v7.6923828h-1.8310547V167.9781952z
          M261.3779297,166.2711639h2.0566406l2.859375,6.9521484l2.859375-6.9521484h2.0566406v9.3994141h-1.7900391v-6.2119141
          l-2.5292969,6.2119141h-1.234375l-2.5507812-6.2119141v6.2119141h-1.7275391V166.2711639z"
                        />
                      </g>

                      <rect x="107.2" y="231.9" fill="#1700F4" width="144.8" height="15.6" />
                    </g>
                  </svg>


                  <strong> {this.renderTrainingName(t)} </strong>

                </strong>
              }

            </td>
            <td className="showGrup">{t.trainingLocation ?? ""}</td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? `${t.timeplans[0].duration}`
                : null}
              <sup>
                <Trans desc="GÜN">10388</Trans>
              </sup>
            </td>
            <td className="showGrup">
              <div id="durumChart_1" data-percent="34">
                {this.renderStatusChart(t.score)}
              </div>
            </td>
            {this.renderSuccessStatus(t.successStatus)}
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? this.renderDateTime(
                  t.trainingMethod.value,
                  t.timeplans[0].startDate
                )
                : null}
            </td>
            <td className="showGrup">
              {t.timeplans !== null && t.timeplans.length > 0
                ? this.renderDateTime(
                  t.trainingMethod.value,
                  t.timeplans[0].endDate
                )
                : null}
            </td>
            <td className="showGrup">{t.isDuplicateTraining ? i18n.t("10504") : i18n.t("10505")}</td>

            <td className="showGrup">{t.importanceLevelCode ?? ""}</td>




            <td className="showGrup">{this.renderDocumentIcon(t)}</td>
            {this.renderContinueAction(t)}

            <td></td>
          </tr>
          {this.renderChildren(t)}
        </DesktopBreakpoint>
        <TabletBreakpoint>
          {isChild ? (
            <div key={t.key} className="card" style={{ marginBottom: "0" }}>
              <div className="card-header">
                <a
                  className="btn btn-link"
                  type="button"
                  onClick={this.toggleChildren}
                >
                  <h2 className="mb-0">{t.training.name}</h2>
                </a>
              </div>
            </div>
          ) : (
            <tr key={t.key} className={this.rowClassName}>
              {this.renderTrainingMethodIcon(
                t.trainingMethod.value,
                t.isParent
              )}
              <td
                onClick={() => this.showDetail(t, this.props.parentId)}
                className="showGrup"
              >
                {this.renderTrainingName(t)}
              </td>
            </tr>
          )}
          {this.renderTabletModeDetail(t)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modal: state.modal,
  };
};

export default connect(mapStateToProps, { showModal })(RegisteredTraining);
